export const localStorageKeys = {
    isUserPreferredLanguageSet: "isUserPreferredLanguageSet",
    selectedCustomerId: "selectedCustomerId",
};
